// src/components/SubscribePage.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import axios from '../axiosConfig';

const SubscribePage = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [activationKey, setActivationKey] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const key = queryParams.get('key');
    if (key) {
      setActivationKey(key);
    }
  }, [location.search]);

  const handleSubscription = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await axios.post('/api/change-password', { password, activationKey });
      if (response.status === 200) {
        setSuccess('Password change successful!');
        navigate('/login');
      } else {
        setError('Password change failed');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <Container>
      <SubscribeBox>
        <h1>NexBot - Inscrição</h1>
        <form onSubmit={handleSubscription}>
          <input 
            type="password" 
            placeholder="New Password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
          <input 
            type="password" 
            placeholder="Confirm New Password" 
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required 
          />
          {error && <Error>{error}</Error>}
          {success && <Success>{success}</Success>}
          <button type="submit">Change Password</button>
        </form>
      </SubscribeBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
`;

const SubscribeBox = styled.div`
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 200px;

  form {
    display: flex;
    flex-direction: column;

    input {
      margin: 10px 0;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      width: 90%;
    }

    button {
      padding: 10px;
      border: none;
      border-radius: 4px;
      background-color: #007bff;
      color: white;
      cursor: pointer;
    }
  }
`;

const Error = styled.div`
  color: red;
  margin-bottom: 10px;
`;

const Success = styled.div`
  color: green;
  margin-bottom: 10px;
`;

export default SubscribePage;
